var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg003HumanResources(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Human_Resource-Job_Search-Magnifying_Glass-Paper-Search",
    "data-name": "Human Resource-Job Search-Magnifying Glass-Paper-Search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 11v46a4.015 4.015 0 0 1 -4 4h-36a4 4 0 0 1 -4-4v-50a4 4 0 0 1 4-4h32v6a2.006 2.006 0 0 0 2 2z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 42.74v14.26a3.986 3.986 0 0 1 -.38 1.69l-5.48-5.48a2.005 2.005 0 0 1 -3.42-1.41 2.033 2.033 0 0 1 .59-1.42l-3.35-3.35-.01-.01a17 17 0 1 1 7.07-7.07l.01.01 3.35 3.35a2.006 2.006 0 0 1 1.62-.57z",
    fill: "#d8d7da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.99 51.92-6.99-6.99-.79-.79-2.83-2.83-3.35-3.35-.01-.01a16.894 16.894 0 0 1 -7.07 7.07l.01.01 3.35 3.35 2.83 2.83 7.48 7.48.3.3a5 5 0 0 0 7.07-7.07z",
    fill: "#ee8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.02 37.95a16.894 16.894 0 0 1 -7.07 7.07 17 17 0 1 1 7.07-7.07z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.19 39.19a13 13 0 1 1 0-18.38 12.959 12.959 0 0 1 0 18.38z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 11h-6a2.006 2.006 0 0 1 -2-2v-6z",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.8 42.72a2 2 0 0 1 -.59 1.42l-7.07 7.07a2.005 2.005 0 0 1 -3.42-1.41 2.033 2.033 0 0 1 .59-1.42l7.07-7.07a2.005 2.005 0 0 1 3.42 1.41z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 39.47v.77a12.974 12.974 0 0 1 -16 0v-.77a4.02 4.02 0 0 1 2.21-3.58l1.5-.75 1.29 2.86 3-2 3 2 1.29-2.86 1.5.75a4.02 4.02 0 0 1 2.21 3.58z",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.29 35.14-1.29 2.86-3-2 2-2z",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 36-3 2-1.29-2.86 2.29-1.14z",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 31v3l-2 2-2-2v-3z",
    fill: "#ffc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 31v1.46a3.974 3.974 0 0 1 -4 0v-1.46z",
    fill: "#ffb655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 27v1a4 4 0 0 1 -8 0v-1h.51a5.993 5.993 0 0 0 4.25-1.76l.24-.24.45.89a1.989 1.989 0 0 0 1.79 1.11z",
    fill: "#ffc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 25v2h-.76a1.989 1.989 0 0 1 -1.79-1.11l-.45-.89-.24.24a5.993 5.993 0 0 1 -4.25 1.76h-.51v-2a4 4 0 0 1 8 0z",
    fill: "#57565c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bcbec0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 8h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 12h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 50h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 54h14v2h-14z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg003HumanResources);
export default __webpack_public_path__ + "static/media/003-human-resources.bc424855388d6b7d33eb4e4935793484.svg";
export { ForwardRef as ReactComponent };